import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
	mt: {
		marginTop: "1rem",
		padding: "0.5rem",
	},

	iconAccount: {
		display: "flex",
		alignItems: "flex-end",
		opacity: "20%",
	},
}));
